import * as mobx from 'mobx';

export function setupMobx()
{
    mobx.configure({
        enforceActions: 'observed'
    });
}
